export const SAME_LANE_OFFSET_STEP_METRES = 2.5;

export type LaneSide = 'left' | 'right' | 'centre';

export interface ParsedLane {
  readonly raw: string;
  readonly key: string;
  readonly side: LaneSide;
}

export interface SameLaneOffsetLayerInput {
  readonly id: string;
  readonly lane: string;
}

export function parseLane(lane: string | null | undefined): ParsedLane {
  const raw = typeof lane === 'string' ? lane.trim() : '';
  const key = raw;
  const lower = raw.toLowerCase();

  if (
    /^cl\d*/i.test(raw) ||
    lower === 'left' ||
    lower === 'nearside' ||
    lower === 'l'
  ) {
    return { raw, key, side: 'left' };
  }

  if (
    /^cr\d*/i.test(raw) ||
    lower === 'right' ||
    lower === 'offside' ||
    lower === 'r'
  ) {
    return { raw, key, side: 'right' };
  }

  return { raw, key, side: 'centre' };
}

export function laneSideOffsetDirection(side: LaneSide): 1 | -1 {
  return side === 'right' ? -1 : 1;
}


export function offsetMetresForLaneSlot(side: LaneSide, slot: number): number {
  const direction = laneSideOffsetDirection(side);
  if (side === 'centre') {
    return slot === 0 ? 0 : slot * SAME_LANE_OFFSET_STEP_METRES * direction;
  }
  return (slot + 1) * SAME_LANE_OFFSET_STEP_METRES * direction;
}


export function assignSameLaneOffsetMetres(
  layers: readonly SameLaneOffsetLayerInput[],
): ReadonlyMap<string, number> {
  const groups = new Map<string, SameLaneOffsetLayerInput[]>();

  for (const layer of layers) {
    const { key } = parseLane(layer.lane);
    const groupKey = key.length > 0 ? key : '__empty__';
    const existing = groups.get(groupKey);
    if (existing) {
      existing.push(layer);
    } else {
      groups.set(groupKey, [layer]);
    }
  }

  const offsets = new Map<string, number>();

  for (const group of groups.values()) {
    const side = parseLane(group[0]?.lane).side;

    group.forEach((layer, slot) => {
      offsets.set(layer.id, offsetMetresForLaneSlot(side, slot));
    });
  }

  return offsets;
}
